export const isEqual = (o1, o2) => {
    return JSON.stringify(o1) === JSON.stringify(o2);
};
